// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __, _x } from '@wordpress/i18n';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-log-loop-header' )
export class AutomatorLogItemLoopHeader extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	// Information about what has to be iterated (e.g. users, posts, tokens)
	@property( { type: Object, attribute: false } ) accessor iterableExpression;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div class="header">
				<div class="header-tag">
					<div class="header-tag-icon">
						<uo-icon id="repeat"></uo-icon>
					</div>

					${ escapeHTML( _x( 'Loop', 'Block name, noun', 'uncanny-automator' ) ) }
				</div>

				<div class="header-logic">
					${ this._templateLogicExpression }					
					${ escapeHTML( __( 'that match the following criteria', 'uncanny-automator' ) ) }
				</div>
			</div>
		`;
	}

	/**
	 * Creates the block that shows what type of data we're iterating. E.g. "Users"
	 *
	 * @return {TemplateResult|undefined} The expression/source data
	 */
	get _templateLogicExpression() {
		if ( this.iterableExpression.type === 'users' ) {
			return html`
				<div class="header-logic-expression">
					<uo-icon id="user"></uo-icon>
					${ escapeHTML( __( 'Users', 'uncanny-automator' ) ) }
				</div>
			`;
		}

		if ( this.iterableExpression.type === 'posts' ) {
			return html`
				<div class="header-logic-expression">
					<uo-icon id="files"></uo-icon>
					${ escapeHTML( __( 'Posts', 'uncanny-automator' ) ) }
				</div>
			`;
		}

		if ( this.iterableExpression.type === 'token' ) {
			return html`
				<div class="header-logic-expression header-logic-expression--token">
					${ this._templateIterableExpressionToken }
				</div>
			`;
		}
	}

	/**
	 * If this is a Token Loop, returns the token expression
	 *
	 * @return {TemplateResult|undefined} The token
	 */
	get _templateIterableExpressionToken() {
		// Check if the iterable expression is a token
		if ( this.iterableExpression.type !== 'token' ) {
			return;
		}

		// Check if the backup exists
		if ( ! this.iterableExpression.backup ) {
			return;
		}

		try {
			// Get the backup
			const backup = JSON.parse( this.iterableExpression.backup );

			// Return the sentence
			return html`
				<uap-log-sentence .sentence=${ backup.sentence_html }></uap-log-sentence>
			`;
		} catch ( e ) {
			return;
		}
	}
}